import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'

import { open as openAction } from './miniPlayerActions'
import { play as playAction, pause as pauseAction } from './AudioPlayer/playerActions'
import { notify as notifyAction } from '../notifier/NotifierActions'
import * as selectors from './miniPlayerSelectors'
import * as shapes from '../../constant/shapes'

import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'
import ProgressCircle from './ProgressCircle'
import appConst from '../../constant/appConst'

const handleClick = (e, callback) => {
	if (e.nativeEvent.which === 1 || e.nativeEvent.type === 'touchend') {
		callback()
	}
}

const notificationMessage = (id, intl) => (
	<div>
		<div key="player-message-subscribe">
			<div>
				{intl.formatMessage({ id: 'notifications.subscribe' })}
			</div>
			<a href={appConst.seeSubscribesUrl} target="_blank" className="c2">
				{intl.formatMessage({ id: 'buttons.seeSubscribes' })}
			</a>
		</div>
		<div key="player-message-purchase">
			<div>
				{intl.formatMessage({ id: 'notifications.purchase' })}
			</div>
			<a href={`${appConst.albumOderUrl}${id}`} target="_blank" className="c2">
				{intl.formatMessage({ id: 'buttons.buy' })}
			</a>
		</div>
	</div>
)



class MiniPlayer extends PureComponent {
	render() {
		const { element, buttonClassName, type, isCurrentTrack, playing, sampleable, open, play, pause, notify } = this.props
		const { intl } = this.context

		if (sampleable) {
			if (isCurrentTrack(type, element.id)) {
				if (playing) {
					return (
						<div>
							<ProgressCircle />
							<div onTouchTap={e => handleClick(e, pause)} className={`${buttonClassName} pct pct-pause`} />
						</div>
					)
				}
				return (
					<div>
						<ProgressCircle />
						<div onTouchTap={e => handleClick(e, play)} className={`${buttonClassName} pct pct-play`} />
					</div>
				)
			}
			return (<div onTouchTap={e => handleClick(e, () => open(element, type))} className={`${buttonClassName} pct pct-play`} />)
		}
		return (
			<div
				className={`${buttonClassName} pct pct-play`}
				onTouchTap={e => handleClick(e, () => notify({
					message: <div className="notification-content">{notificationMessage(element.albumId || element.id, intl)}</div>,
					level: 'info',
					autoDismiss: 5
				}))}
			/>
		)
	}

}

MiniPlayer.propTypes = {
	element: PropTypes.oneOfType([shapes.trackItem, shapes.albumCard]).isRequired,
	buttonClassName: PropTypes.string,
	type: PropTypes.oneOf([ORIGIN_PLAYQUEUE_TYPES.track, ORIGIN_PLAYQUEUE_TYPES.album]).isRequired,
	sampleable: PropTypes.bool.isRequired,
	isCurrentTrack: PropTypes.func,
	playing: PropTypes.bool,
	play: PropTypes.func,
	pause: PropTypes.func,
	open: PropTypes.func,
	notify: PropTypes.func
}

MiniPlayer.defaultProps = {
	buttonClassName: "track-player"
}

MiniPlayer.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state) => ({
	playing: selectors.isPlaying(state),
	isCurrentTrack: (type, idElement) => selectors.isCurrentTrack(state)(type, idElement)
})

const actions = {
	open: openAction,
	play: playAction,
	pause: pauseAction,
	notify: notifyAction
}

export default connect(mapStateToProps, actions)(MiniPlayer)



// WEBPACK FOOTER //
// ./src/components/miniPlayer/MiniPlayer.jsx